import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCards, deleteCard } from '../utils/cardStorage';
import { NotificationManager } from '../components/Notification';
import '../styles/Home.css';

const Home = () => {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  
  useEffect(() => {
    // Charger les profils au chargement de la page
    loadCards();
  }, []);
  
  const loadCards = () => {
    const loadedCards = getCards();
    // Trier les cartes par ordre alphabétique
    loadedCards.sort((a, b) => {
      const nameA = `${a.firstName} ${a.lastName}`.trim().toLowerCase();
      const nameB = `${b.firstName} ${b.lastName}`.trim().toLowerCase();
      return nameA.localeCompare(nameB);
    });
    setCards(loadedCards);
  };
  
  const handleDelete = (id, e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette carte ?')) {
      deleteCard(id);
      loadCards();
      NotificationManager.show('Succès', 'Carte supprimée avec succès', 'success');
    }
  };
  
  const getInitials = (firstName, lastName) => {
    const first = firstName ? firstName.charAt(0) : '';
    const last = lastName ? lastName.charAt(0) : '';
    return (first + last).toUpperCase();
  };
  
  return (
    <div className="container">
      <div className="sidebar">
        <h2>Paramètres de l'entreprise</h2>
        <div className="server-info">
          <p>Application de gestion de cartes de visite</p>
          <p>Version 1.0</p>
        </div>
        
        <h2>Cartes enregistrées</h2>
        <div className="card-list">
          {cards.length === 0 ? (
            <div className="empty-message">Aucune carte enregistrée</div>
          ) : (
            cards.map(card => (
              <div key={card.id} className="card-item" onClick={() => navigate(`/profile/${card.id}`)}>
                <div className="card-item-content">
                  <div className="card-item-photo">
                    {card.photoUrl ? (
                      <img src={card.photoUrl} alt={`${card.firstName} ${card.lastName}`} />
                    ) : (
                      <div className="photo-placeholder">
                        {getInitials(card.firstName, card.lastName)}
                      </div>
                    )}
                  </div>
                  <div>
                    <div className="card-item-title">{`${card.firstName} ${card.lastName}`.trim() || 'Sans nom'}</div>
                    <div className="card-item-subtitle">{card.title || 'Poste non spécifié'}</div>
                  </div>
                </div>
                <div className="card-actions">
                  <button 
                    className="card-btn" 
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/edit/${card.id}`);
                    }}
                  >
                    ✏️
                  </button>
                  <button 
                    className="card-btn delete"
                    onClick={(e) => handleDelete(card.id, e)}
                  >
                    🗑️
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
        
        <button 
          className="btn-primary btn-block" 
          style={{ marginTop: '15px' }}
          onClick={() => navigate('/add')}
        >
          + Nouvelle carte
        </button>
        
        <div className="export-container">
          <h2>Paramètres</h2>
          <button 
            className="btn-primary btn-block"
            onClick={() => navigate('/settings')}
          >
            ⚙️ Paramètres généraux
          </button>
        </div>
      </div>
      
      <div className="main-content">
        <h1>Générateur de cartes de visite</h1>
        
        {cards.length === 0 ? (
          <div className="welcome-screen">
            <div className="welcome-icon">👋</div>
            <h2>Bienvenue dans votre gestionnaire de cartes de visite</h2>
            <p>Commencez par créer votre première carte de visite en cliquant sur le bouton ci-dessous</p>
            <button 
              className="btn-primary btn-large" 
              onClick={() => navigate('/add')}
            >
              Créer ma première carte
            </button>
          </div>
        ) : (
          <div className="cards-grid">
            {cards.map(card => (
              <div key={card.id} className="card-preview-item" onClick={() => navigate(`/profile/${card.id}`)}>
                <div className="card-preview-header">
                  <div className="card-preview-photo">
                    {card.photoUrl ? (
                      <img src={card.photoUrl} alt={`${card.firstName} ${card.lastName}`} />
                    ) : (
                      <div className="photo-placeholder">
                        {getInitials(card.firstName, card.lastName)}
                      </div>
                    )}
                    {card.companyLogo && (
                      <div className="card-preview-logo">
                        <img src={card.companyLogo} alt={`Logo ${card.company || 'entreprise'}`} />
                      </div>
                    )}
                  </div>
                  <div className="card-preview-info">
                    <h3>{`${card.firstName} ${card.lastName}`.trim() || 'Sans nom'}</h3>
                    <p>{card.title || 'Poste non spécifié'}</p>
                    {card.company && <p className="card-preview-company">{card.company}</p>}
                  </div>
                </div>
                <div className="card-preview-actions">
                  <button 
                    className="card-action-btn edit" 
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/edit/${card.id}`);
                    }}
                  >
                    Modifier
                  </button>
                  <button 
                    className="card-action-btn view"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/profile/${card.id}`);
                    }}
                  >
                    Voir
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;